module.exports = __webpack_public_path__ + "img/ask_b.280e07d3.png";